import { useState, useEffect } from 'react';
import { api } from '@/App';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { FileText, Download } from 'lucide-react';
import { toast } from 'sonner';

export default function InvoiceManagement() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBookings();
  }, []);

  const loadBookings = async () => {
    try {
      const response = await api.get('/bookings?status=checked_in');
      setBookings(response.data);
    } catch (error) {
      toast.error('Failed to load bookings');
    } finally {
      setLoading(false);
    }
  };

  const generateInvoice = async (bookingId) => {
    try {
      const response = await api.post(`/invoices?booking_id=${bookingId}`);
      toast.success('Invoice generated successfully');
      console.log('Invoice:', response.data);
    } catch (error) {
      toast.error('Failed to generate invoice');
    }
  };

  return (
    <div className="space-y-6" data-testid="invoice-management">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight" style={{ fontFamily: 'Manrope' }}>Invoice Management</h1>
        <p className="text-muted-foreground mt-1">Generate and manage invoices</p>
      </div>

      {loading ? (
        <div className="text-center py-12">Loading...</div>
      ) : (
        <div className="space-y-4">
          {bookings.map(booking => (
            <Card key={booking.id} className="hover-lift" data-testid={`invoice-booking-${booking.id}`}>
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center">
                      <FileText className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <p className="font-semibold" style={{ fontFamily: 'JetBrains Mono' }}>
                        Booking #{booking.id.slice(0, 8)}
                      </p>
                      <p className="text-sm text-muted-foreground">
                        {new Date(booking.check_in).toLocaleDateString()} - {new Date(booking.check_out).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <p className="text-xs text-muted-foreground uppercase tracking-wider">Amount</p>
                      <p className="text-xl font-bold" style={{ fontFamily: 'JetBrains Mono' }}>
                        ₹{booking.total_amount}
                      </p>
                    </div>
                    <Button
                      onClick={() => generateInvoice(booking.id)}
                      data-testid={`generate-invoice-${booking.id}`}
                    >
                      <Download className="h-4 w-4 mr-2" />
                      Generate Invoice
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      {!loading && bookings.length === 0 && (
        <Card>
          <CardContent className="py-12 text-center">
            <FileText className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
            <p className="text-muted-foreground">No active bookings for invoicing</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}